// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__NWffd","row":"Menu_row__8EZ4z","department":"Menu_department__axaBc","active":"Menu_active__6OnwZ"};